import { Injectable } from '@angular/core';
import {
  DaysOfWeek,
  GetCalenderByDateTImeDto,
  GetEnumValuesDto,
} from 'src/app/core/api/models';
import { SmartSmsRequestPeriodicPatterns } from '../../../../../core/api/models/smart-sms-request-periodic-patterns';
import { CalenderData } from 'src/app/pages/facility/calendar-event/calender/calender-data.model';

@Injectable({
  providedIn: 'root',
})
export class SmartSmsPeriodicPatternsStateService {
  selectAll(days: CalenderData[], isSelected: boolean = true): CalenderData[] {
    days = days.map((c) => ({
      ...c,
      selected: c.disabled ? false : isSelected,
    }));
    return days;
  }

  /** first atDates and second solarDates */
  getSelectedDays(days: CalenderData[]): [string[], string[]] {
    const atDates = days
      .filter((d) => d.selected && !d.disabled)
      .map((d) => d.dateTime);
    const solarDates = days
      .filter((d) => d.selected && !d.disabled)
      .map((d) => d.solarDate);
    return [atDates, solarDates];
  }

  applySelectedDays(
    days: CalenderData[],
    selectedDays: string[]
  ): CalenderData[] {
    return days.map((d) => ({
      ...d,
      selected: selectedDays.includes(d.dateTime),
    }));
  }

  mapMatAdDateToDateTime(atDate: string, addTime: boolean) {
    const d = atDate?.trim()?.split('/');
    const standardDate = `${d[2]}-${d[0]}-${d[1]}${
      addTime ? 'T00:00:00Z' : ''
    }`;
    return standardDate;
  }

  mapSolarDate(
    day: GetCalenderByDateTImeDto,
    daysOfWeekEnumValues?: GetEnumValuesDto[]
  ): string {
    const dayOfWeekName = daysOfWeekEnumValues.find(
      (d) => d.key == day.daysOfWeek
    ).value;
    return `${dayOfWeekName} ${day.solarDate}`;
  }

  mapAndInitialCalenderData(
    calenderItems: GetCalenderByDateTImeDto[],
    daysOfWeekEnumValues: GetEnumValuesDto[]
  ): CalenderData[] {
    return calenderItems
      .map((c) => c as CalenderData)
      .map((c) => ({
        ...c,
        selected: false,
        disabled: false,
        solarDate: this.mapSolarDate(c, daysOfWeekEnumValues),
        adDate: this.mapMatAdDateToDateTime(c.adDate, false),
        dateTime: this.mapMatAdDateToDateTime(c.adDate, true),
      }));
  }

  disableInvalidDays(
    days: CalenderData[],
    startDateTime: string,
    endDateTime: string
  ): CalenderData[] {
    const startDate = new Date(startDateTime?.split('T')[0]);
    const endDate = new Date(endDateTime?.split('T')[0]);
    days.forEach((day) => {
      const dayDate = new Date(day.adDate);
      if (dayDate > endDate || dayDate < startDate) day.disabled = true;
    });
    return days;
  }

  applyPeriodicPattern(
    days?: CalenderData[],
    pattern?: SmartSmsRequestPeriodicPatterns
  ) {
    if (pattern === undefined || pattern === null)
      pattern = SmartSmsRequestPeriodicPatterns.DaysOfWeek;

    //ریست کردن حالت های قبلی
    if (pattern != SmartSmsRequestPeriodicPatterns.Custom)
      days = this.selectAll(days, false);

    const allDays = days;
    let result;

    switch (pattern) {
      // ^همه روزهای هفته
      case SmartSmsRequestPeriodicPatterns.DaysOfWeek:
        result = this.selectAll(allDays, true);
        break;
      //^روزهای زوج هفته
      case SmartSmsRequestPeriodicPatterns.EvenDaysOfWeek:
        result = this.selectEvenDaysOfWeek(allDays);
        break;
      //^روزهای فرد هفته
      case SmartSmsRequestPeriodicPatterns.OddDaysOfWeek:
        result = this.selectOddDaysOfWeek(allDays);
        break;
      //^دو روز آخر هفته
      case SmartSmsRequestPeriodicPatterns.LastTwoDaysOfWeek:
        result = this.selectLastTwoDaysOfWeek(allDays);
        break;
      // ^دو روز آخر ماه
      case SmartSmsRequestPeriodicPatterns.LastTwoDaysOfMonth:
        result = this.selectLastTwoDaysOfMonth(allDays);
        break;
      // ^دو روز اول ماه
      case SmartSmsRequestPeriodicPatterns.FirstTwoDaysOfMonth:
        result = this.selectFirstTwoDaysOfMonth(allDays);
        break;
    }
    return result || allDays;
  }

  selectEvenDaysOfWeek(days: CalenderData[]) {
    return days.map((c) =>
      [DaysOfWeek.Saturday, DaysOfWeek.Monday, DaysOfWeek.Wednesday].includes(
        c.daysOfWeek
      )
        ? { ...c, selected: c.disabled ? false : true }
        : { ...c }
    );
  }

  selectOddDaysOfWeek(days: CalenderData[]) {
    return days.map((c) =>
      [DaysOfWeek.Sunday, DaysOfWeek.Tuesday, DaysOfWeek.Thursday].includes(
        c.daysOfWeek
      )
        ? { ...c, selected: c.disabled ? false : true }
        : { ...c }
    );
  }

  selectLastTwoDaysOfWeek(days: CalenderData[]) {
    return days.map((c) =>
      [DaysOfWeek.Thursday, DaysOfWeek.Friday].includes(c.daysOfWeek)
        ? { ...c, selected: c.disabled ? false : true }
        : { ...c }
    );
  }

  selectLastTwoDaysOfMonth(days: CalenderData[]) {
    return days.map((c) =>
      c.day >= 29 ? { ...c, selected: c.disabled ? false : true } : { ...c }
    );
  }

  selectFirstTwoDaysOfMonth(days: CalenderData[]) {
    return days.map((c) =>
      c.day < 3 ? { ...c, selected: c.disabled ? false : true } : { ...c }
    );
  }
}

export interface SmartSmsRequestPeriodicPatternsDialogData {
  calenderItems?: CalenderData[];
  periodicPattern?: SmartSmsRequestPeriodicPatterns;
  selectedDays?: string[];
  selectedSolarDays?: string[];
  periodicPatternsEnumValues?: GetEnumValuesDto[];
  daysOfWeekEnumValues?: GetEnumValuesDto[];
  isReadonly?:boolean;
}
